import React from "react";
import { Link2, Clock3, AlertTriangle } from "lucide-react";
import { useI18n } from "@/i18n";

export function TrustBadge({ status, mode }) {
  const { t } = useI18n();
  if (status === "verified" && mode === "minimal") return null;
  if (status === "verified") {
    return (
      <span data-testid="trust-badge-attributed" className="inline-flex items-center gap-1 text-[11px] font-medium text-emerald-600">
        <Link2 size={13} /> {t("common.verified")}
      </span>
    );
  }
  if (status === "pending") {
    return (
      <span data-testid="trust-badge-pending" className="inline-flex items-center gap-1 text-[11px] font-medium text-amber-600">
        <Clock3 size={13} /> {t("common.pending")}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 text-[11px] font-medium text-rose-600">
      <AlertTriangle size={13} /> {status === "failed" ? t("common.failed") : t("common.removed")}
    </span>
  );
}
